// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BLOG_POST_EDIT_MENU = "Uprav";
export const BLOG_REPORT_POST = "Nahl\u00e1si\u0165 pr\u00edspevok";
export const DELETE = "Zma\u017e";
export const GROUP_DONT_SHOW_POSTS_FROM_group = "Nezobrazuj pr\u00edspevky skupiny %(group)s";
export const GROUP_LEAVE_group = "Opusti skupinu %(group)s";
export const PIN_POST = "Pripn\u00fa\u0165 hore";
export const SEND_HEART_TO_username = "Po\u0161li srdie\u010dko %(username)s";
export const SHOW_USERS_WHO_LIKED_THIS_POST = "Zobraz u\u017e\u00edvate\u013eky, ktor\u00fdm sa to p\u00e1\u010di";
export const UNPIN_POST = "Zru\u0161i\u0165 pripnutie";
